// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { DigitalPaymentV1ClientGeneratedCounterpartyEntityDetail } from './digitalPaymentV1ClientGeneratedCounterpartyEntityDetail.js';
import type { DigitalPaymentV1ClientGeneratedCounterpartyUserDetail } from './digitalPaymentV1ClientGeneratedCounterpartyUserDetail.js';
import type { DigitalPaymentV1ClientGeneratedExternalAccountDetail } from './digitalPaymentV1ClientGeneratedExternalAccountDetail.js';
import type { DigitalPaymentV1ClientGeneratedRejectDetails } from './digitalPaymentV1ClientGeneratedRejectDetails.js';
import type { DigitalPaymentV1ClientGeneratedReturnDetails } from './digitalPaymentV1ClientGeneratedReturnDetails.js';
import type { DigitalPaymentV1ClientGeneratedTransactionReference } from './digitalPaymentV1ClientGeneratedTransactionReference.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class DigitalPaymentV1ClientGeneratedTransactionWebhookPayload {
    'methodOfPaymentType': string;
    'methodOfPaymentSubType'?: string | null;
    'status': string;
    'externalAccount'?: DigitalPaymentV1ClientGeneratedExternalAccountDetail | null;
    'returnDetails'?: DigitalPaymentV1ClientGeneratedReturnDetails | null;
    'rejectDetails'?: DigitalPaymentV1ClientGeneratedRejectDetails | null;
    'invoicePayableNumbers': Array<string>;
    'confirmationNumber': string;
    'endToEndId'?: string | null;
    'valueDate'?: Moment | null;
    'createDateTime': Moment;
    'effectiveDate'?: Moment | null;
    'createdBy': string;
    'creditOrDebit': string;
    'currency': string;
    'paymentAmount'?: number;
    'counterpartyEntity': DigitalPaymentV1ClientGeneratedCounterpartyEntityDetail | null;
    'counterpartyUser': DigitalPaymentV1ClientGeneratedCounterpartyUserDetail | null;
    'transactionReferences'?: Array<DigitalPaymentV1ClientGeneratedTransactionReference> | null;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof DigitalPaymentV1ClientGeneratedTransactionWebhookPayload>> = [
        {
            "name":     "methodOfPaymentType",
            "baseName": "methodOfPaymentType",
            "type":     "string"
        },
        {
            "name":     "methodOfPaymentSubType",
            "baseName": "methodOfPaymentSubType",
            "type":     "string"
        },
        {
            "name":     "status",
            "baseName": "status",
            "type":     "string"
        },
        {
            "name":     "externalAccount",
            "baseName": "externalAccount",
            "type":     "DigitalPaymentV1ClientGeneratedExternalAccountDetail"
        },
        {
            "name":     "returnDetails",
            "baseName": "returnDetails",
            "type":     "DigitalPaymentV1ClientGeneratedReturnDetails"
        },
        {
            "name":     "rejectDetails",
            "baseName": "rejectDetails",
            "type":     "DigitalPaymentV1ClientGeneratedRejectDetails"
        },
        {
            "name":     "invoicePayableNumbers",
            "baseName": "invoicePayableNumbers",
            "type":     "Array<string>"
        },
        {
            "name":     "confirmationNumber",
            "baseName": "confirmationNumber",
            "type":     "string"
        },
        {
            "name":     "endToEndId",
            "baseName": "endToEndId",
            "type":     "string"
        },
        {
            "name":     "valueDate",
            "baseName": "valueDate",
            "type":     "Date"
        },
        {
            "name":     "createDateTime",
            "baseName": "createDateTime",
            "type":     "Date"
        },
        {
            "name":     "effectiveDate",
            "baseName": "effectiveDate",
            "type":     "Date"
        },
        {
            "name":     "createdBy",
            "baseName": "createdBy",
            "type":     "string"
        },
        {
            "name":     "creditOrDebit",
            "baseName": "creditOrDebit",
            "type":     "string"
        },
        {
            "name":     "currency",
            "baseName": "currency",
            "type":     "string"
        },
        {
            "name":     "paymentAmount",
            "baseName": "paymentAmount",
            "type":     "number"
        },
        {
            "name":     "counterpartyEntity",
            "baseName": "counterpartyEntity",
            "type":     "DigitalPaymentV1ClientGeneratedCounterpartyEntityDetail"
        },
        {
            "name":     "counterpartyUser",
            "baseName": "counterpartyUser",
            "type":     "DigitalPaymentV1ClientGeneratedCounterpartyUserDetail"
        },
        {
            "name":     "transactionReferences",
            "baseName": "transactionReferences",
            "type":     "Array<DigitalPaymentV1ClientGeneratedTransactionReference>"
        },
    ];

    static getAttributeTypeMap() {
        return DigitalPaymentV1ClientGeneratedTransactionWebhookPayload.attributeTypeMap;
    }
}
